/* istanbul ignore file */
import actions from '../actions';
import Comments from './comments';
import {connect} from 'react-redux';
import {getCommentsModalState} from '../selectors';
import ListingPreview from '../../listing/listing-preview';
import Modal from '@homeaway/react-modal';
import PdpButton from '../../listing/listing-pdp-button';
import React from 'react';
import Votes from '../../votes/votes';
import './comments-modal.less';

export const isLarge = () => {
    return typeof window !== 'undefined' && window.innerHeight && window.innerHeight > 1024;
};

export function CommentsModal({
    availableForDates,
    baseLocation,
    boardId,
    detailPageUrl,
    endDate,
    hasCarousel,
    isOpen,
    listingId,
    onClose,
    startDate,
    ...rest // remaining props come from listing partial
}) {
    const isLargeSize = isLarge();
    return (
        <Modal
            id="comments-modal"
            className={`comments-modal ${isLargeSize ? 'lg' : ''}`}
            isOpen={isOpen}
            onClose={onClose}
            title={
                <PdpButton
                    boardId={boardId}
                    detailPageUrl={detailPageUrl}
                    endDate={endDate}
                    listingId={listingId}
                    size="xs"
                    startDate={startDate}
                />
            }
        >
            <div className="comments-modal__body">
                <div className="comments-modal__listing">
                    <ListingPreview
                        availableForDates={availableForDates}
                        baseLocation={baseLocation}
                        boardId={boardId}
                        detailPageUrl={detailPageUrl}
                        endDate={endDate}
                        hasCarousel={hasCarousel}
                        listingId={listingId}
                        size={isLargeSize ? 'lg' : null}
                        startDate={startDate}
                        {...rest}
                    />
                </div>
                <div className="comments-modal__comments">
                    <hr className="comments-modal__hr comments-modal__hr--votes" />
                    <div className="comments-modal__comments__header">
                        <Votes
                            className="comments-modal__votes"
                            endDate={endDate}
                            listingId={listingId}
                            tripBoardUuid={boardId}
                            showLabel
                            showVoters
                            startDate={startDate}
                        />
                    </div>
                    <hr className="comments-modal__hr" />
                    <Comments
                        boardId={boardId}
                        endDate={endDate}
                        listingId={listingId}
                        startDate={startDate}
                    />
                </div>
            </div>
        </Modal>
    );
}

CommentsModal.defaultProps = {
    onClose: () => {}
};

export const mapStateToProps = (state) => (getCommentsModalState(state));

export const mapDispatchToProps = {
    onClose: actions.close
};

export default connect(mapStateToProps, mapDispatchToProps)(CommentsModal);



// WEBPACK FOOTER //
// ./src/universal/tripboard/comments/components/comments-modal.js